<template>
  <div class="c-evaluate">
    <span class="c-evaluate__header">测评效果图</span>
    <div class="c-evaluate__bgc">
      <div class="evaluate-effect"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'EvaluateEffect',
  props: {
    graspList: {
      require: true,
      default: () => [],
    },
  },
  mounted() {
    // this.initCharts();
  },
  watch: {
    graspList() {
      this.initCharts();
    },
  },
  methods: {
    initCharts() {
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.querySelector('.evaluate-effect'));
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: 'axis',
          formatter(params) {
            // 暂时不要header
            // const headerName = params.length && `<div style="text-align:center;">
            // ${params[0].name}</div>`;
            const customList = params.length && params.map((item) => `平均掌握程度:${item.value || 0}%</br>`);
            return customList.join('');
          },
        },
        xAxis: {
          type: 'category',
          data: this.graspList.map((item) => item.grade),
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: '#fff',
              fontSize: '12',
            },
          },
          axisLine: {
            show: false,
          },
        },
        yAxis: {
          type: 'value',
          max: 100,
          min: 0,
          name: '平均掌握程度',
          nameTextStyle: { // name样式修改
            align: 'center',
            color: '#C5C3DE',
            padding: [0, 0, 20, 20],
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: ['rgba(255, 255, 255, 0.3)'],
            },
          },
          axisLabel: {
            formatter: '{value} %',
            textStyle: {
              show: true,
              interval: 'auto',
              formatter: '{value} %',
              color: '#fff',
              fontSize: '12',
            },
          },
        },
        series: [{
          data: this.graspList.map((item) => item.lv),
          type: 'bar',
          barMaxWidth: 24,
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#00F1FF',
              }, {
                offset: 0.72,
                color: '#48A6FF',
              }, {
                offset: 1,
                color: '#8A4FFF',
              }]),
              label: {
                formatter(params) {
                  return `${params.data}%`;
                },
                show: true,
                position: 'top',
                textStyle: {
                  fontWeight: 500,
                  fontSize: '12',
                  color: '#fff',
                },

              },
            },
          },
        }],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.c-evaluate{
  box-sizing: border-box;
  &__header {
     display: block;
        position: relative;
        font-size: 28px;
        font-weight: 500;
        text-indent: 1em;
        color: #E3E2FF;
        &::before {
          content: '';
          position: absolute;
          width: 27px;
          height: 27px;
          top: 9px;
          left: -8px;
          background: url('../../images/cockpit-icon.png') no-repeat center / contain;
    }
  }
  &__bgc{
    margin-top:30px ;
    position: relative;
    width: 666px;
    height: 446px;
    background: linear-gradient(180deg, rgba(50, 191, 255, 0.4) 0%, rgba(107, 70, 252, 0.4) 100%);
    border-radius: 8px ;
    // opacity: 0.38;
    }
    .evaluate-effect{
      position: absolute;
      top: 0;
      left: 0;
      width: 666px;
      height: 446px;
    }
  }

</style>
